import React from "react";
import "./social-media.scss";

const socialMedia = () => {
  return (
    <div className="social-icons">
      <a
        className="social-icon social-icon--github"
        target="_blank"
        rel="noopener noreferrer"
        href="https://github.com/vipul-zambare006"
      >
        <i className="fa fa-github"></i>
        <div className="tooltip">Github</div>
      </a>
      <a
        className="social-icon social-icon--email"
        href="mailto:vipulzambare1993@gmail.com"
      >
        <i className="fa fa-envelope"></i>
        <div className="tooltip">Email</div>
      </a>
      <a
        className="social-icon social-icon--linkedin"
        target="_blank"
        rel="noopener noreferrer"
        href="https://www.linkedin.com/in/vipul-zambare/"
      >
        <i className="fa fa-linkedin"></i>
        <div className="tooltip">LinkedIn</div>
      </a>
      <a
        className="social-icon social-icon--instagram"
        target="_blank"
        rel="noopener noreferrer"
        href="https://www.instagram.com/vipul_zambare/"
      >
        <i className="fa fa-instagram"></i>
        <div className="tooltip">Instagram</div>
      </a>
      {/* <a href="#" className="social-icon social-icon--facebook">
        <i className="fa fa-facebook"></i>
        <div className="tooltip">Facebook</div>
      </a> */}
    </div>
  );
};

export default socialMedia;
